<template>
  <div class="products__wrapper">
    <div
      v-for="(product, index) in products"
      :key="index"
      :class="product.className"
      class="product__container"
    >
      <img
        :src="product.imageSmall"
        :alt="product.name"
        class="product__image"
      >
      <div class="product__name">
        <template v-if="product.nameChunks">
          <div class="product__name--one">
            {{ product.nameChunks[0] }}
          </div>
          <div class="product__name--two">
            {{ product.nameChunks[1] }}
          </div>
        </template>
        <template v-else>
          {{ product.name }}
        </template>
      </div>
      <div class="product__type">
        {{ product.type }}
      </div>
      <a
        class="product__link"
        @click="scrollTo(`#product-${product.id}`)"
      >
        more
      </a>
    </div>
  </div>
</template>
<script>
import ScrollMixin from '@/components/mixins/ScrollMixin';

export default {
  name: 'ProductsComponent',
  mixins: [ScrollMixin],
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
};
</script>
<style
  lang="scss"
  scoped
>
  .products {
    &__wrapper {
      width: 100%;
      display: flex;
      justify-content: space-around;
      padding: 66px 44px 57px;
      box-sizing: border-box;

      @include respond-to(tablet-small) {
        flex-wrap: wrap;
      }

      @include respond-to(mobile) {
        padding: 34px 23px 30px;
      }
    }
  }

  .product {
    &__container {
      max-width: 230px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      @include respond-to(tablet-small) {
        max-width: 100%;
        width: 50%;
        flex: 0 0 auto;

        &:nth-of-type(2n) {
          margin-bottom: 64px;
        }

        &:last-of-type {
          margin-bottom: 0;
        }
      }

      &.mint {
        .product {
          &__name {
            color: $theme-color-text-mint;
          }
        }
      }

      &.cake {
        .product {
          &__name {
            color: $theme-color-text-cake;
          }
        }
      }

      &.apple {
        .product {
          &__name {
            color: $theme-color-text-apple;
          }
        }
      }

      &.berry {
        .product {
          &__name {
            color: $theme-color-text-berry;
          }
        }
      }
    }

    &__image {
      max-width: 69px;
      align-self: center;
      margin-bottom: 36px;

      @include respond-to(mobile) {
        max-width: 36px;
      }
    }

    &__name {
      font-size: 2.2em;
      height: 73px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      &--two {
        margin-top: -13px;
      }

      @include respond-to(mobile) {
        font-size: 1.4em;
        height: 29px;

        &--two {
          margin-top: -7px;
        }
      }
    }

    &__type {
      font-size: 1.7em;

      @include respond-to(mobile) {
        font-size: 1em;
      }
    }

    &__link {
      font-size: 1.05em;
      text-decoration: none;
      color: $theme-color-accent;
      border: 1px solid $theme-color-accent;
      padding: 8px 13px 5px;
      margin-top: 9px;
      display: inline-block;
      cursor: pointer;

      @include respond-to(mobile) {
        margin-top: 4px;
        font-size: 0.6em;
        padding: 4px 8px 2px;
      }
    }
  }
</style>
